import { Carousel } from '@pcln/horizon'
import { RecentSearchCard } from '@pcln/trip-activity-components'
import { useEffect, useMemo } from 'react'
import { fireRecentSearchLoadEvent } from './ga4'
import type { RecentSearchAndPriceWatchList } from './types'
import { getPriceWatchProps, getRecentSearchDisplayProps, onCardClick } from './utils'

export default function RecentSearchAndPriceWatchCarousel({
  pageName,
  items,
}: Readonly<{
  pageName: 'homepage' | 'landing'
  items: RecentSearchAndPriceWatchList
}>) {
  useEffect(() => {
    if (items.length > 0) {
      fireRecentSearchLoadEvent(items, pageName)
    }
  }, [items, pageName])

  const slides = useMemo(
    () =>
      items.map((item, index) => {
        if ('isPriceWatch' in item) {
          const { heading, icon, actionText, relativeUrl, priceWatch } = getPriceWatchProps(item)
          return {
            id: `price-watch-${heading || index}`,
            childrenNodes: (
              <RecentSearchCard
                isPriceWatch
                priceWatch={priceWatch}
                headingWidth={['224px', null, null, '250px']}
                icon={icon}
                heading={heading}
                actionText={actionText}
                overline='Price Watch'
                onClick={() => {
                  onCardClick(item, relativeUrl, pageName, item.productType)
                }}
                handleSubmitCTA={() => {
                  onCardClick(item, relativeUrl, pageName, item.productType)
                }}
                className='full-width'
                isIconRounded
              />
            ),
          }
        }

        const { overline, heading, icon, actionText, relativeUrl } = getRecentSearchDisplayProps(item)
        return {
          id: `recent-search-${overline || index}`,
          childrenNodes: (
            <RecentSearchCard
              headingWidth={['224px', null, null, '250px']}
              icon={icon}
              heading={heading}
              actionText={actionText}
              overline={overline}
              onClick={() => {
                onCardClick(item, relativeUrl, pageName, item.productType)
              }}
              handleSubmitCTA={() => {
                onCardClick(item, relativeUrl, pageName, item.productType)
              }}
              className='full-width'
              isIconRounded
            />
          ),
        }
      }),
    [items, pageName],
  )

  return (
    <Carousel
      ariaLabel='Your recent searches and price watches'
      dragFree
      numSlides='one-two-three'
      slides={slides}
      slideWidth='same'
      pagination='numbers'
      type='content'
    />
  )
}
